<template>
  <button id="odd-button"
          v-on:click="addBet()" :class="qbutOdd.change+' odd-c-'+odd.id+' '+activeClass"
          class="OddResult-styles-odd-button OddResult-styles-desktop"
  >
    <div class="OddResult-styles-label-cell OddResult-styles-center-aligned">
      <span class="notranslate">{{odd.outcome}}</span>
    </div>
    <div class="OddResult-styles-value-cell notranslate">
      <span v-show="odd.odd > 1">{{ odd.odd }}</span>
      <span v-show="odd.odd <= 1"><i class="iconx icon-lock"></i></span>
    </div>
  </button>
</template>

<script>
export default {
  name: "SelectionButton",
  props: ['odd', 'match', 'market', 'selectedOdds', 'mode'],
  data() {
    return {
      newOdd: null,
      classState: null,
      selected: null,
      classInstance: null,
      reactiveProp: 0,
      activeClass: '',
      qbutOdd: {change: ''}
    }
  },
  watch: {
    odd: {
      handler(n, o) {

        if(o.odd > n.odd)
          this.qbutOdd.change = 'EventOddButton-styles-tenddown EventOddButton-styles-odd-change-arrow';

        if(o.odd < n.odd)
          this.qbutOdd.change = 'EventOddButton-styles-tendup EventOddButton-styles-odd-change-arrow';

        setTimeout(() => {
          this.qbutOdd.change = '';
          
        }, 2000);

      },
      deep: true,
    },
    '$store.state.activeMarket' (v) {
      if(v.oddId === this.odd.id){
          this.activeClass = 'active-odd-button'
      }
    },
    '$store.state.removeMarket' (v) {
      if(v.oddId === this.odd.id){
          this.activeClass = ''
      }
    },
  },
  beforeDestroy() {
  },
  mounted() {
    this.fetchSelectedBets();

    if(this.odd)
      this.qbutOdd = this.odd;

    this.qbutOdd.class = '';
  },
  methods: {
    addBet () {
      this.$bus.$emit('betAdd', {bet: this.odd, market: this.market, match: this.match});
    },
    checkClass () {
    },
    fetchSelectedBets() {

      var self = this
        this.$getItem('bets', function (key, value) {

          value.forEach((v, k) => {
            if(v.oddId === self.odd.id){
              self.qbutOdd.change = 'active-odd-button'
            }
          });

        }, function (err) {
        })
    },
  }
}
</script>

<style scoped>
.closed {
  opacity: 0.5;
}

.active-odd-button {
  background-color: var(--blue-dark);
  color: var(--white);
  border-color: var(--blue-dark);
}

.active-odd-button > .OddResult-styles-label-cell span {
  color: white
}

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/selectionButton.vue